import firebase from "firebase";

// const firebaseArtTest = firebase.initializeApp(
//   {
//     apiKey: "AIzaSyATdxGyhYwvc5sINK5ReAFD08vQXcgTVek",
//     authDomain: "arts-beta.firebaseapp.com",
//     databaseURL: "https://arts-beta-default-rtdb.firebaseio.com",
//     projectId: "arts-beta",
//     storageBucket: "arts-beta.appspot.com",
//     messagingSenderId: "706273503617",
//     appId: "1:706273503617:web:1a29234e38b5fa73b7a080"
//   },
//   "arts-beta"
// );

const firebaseArtTest = firebase.initializeApp(
  {
    apiKey: "AIzaSyBYd5rW6v980E3igzuJD-q_FzQ1Cfugh1s",
    authDomain: "test-art-9071d.firebaseapp.com",
    databaseURL: "https://test-art-9071d-default-rtdb.firebaseio.com",
    projectId: "test-art-9071d",
    storageBucket: "test-art-9071d.appspot.com",
    messagingSenderId: "240087720142",
    appId: "1:240087720142:web:b4b1c8620de284b296709f",
    measurementId: "G-GPVYZH9J06",
    auth: { studentId: "3" },
  },
  "arts-beta-test"
);

const firebaseArtProd = firebase.initializeApp(
  {
    apiKey: "AIzaSyBzh4IyX9JFTIrl4GUz9kJyEkDWmaaN_jI",
    authDomain: "whjr-arts.firebaseapp.com",
    databaseURL: "https://whjr-arts-default-rtdb.firebaseio.com",
    projectId: "whjr-arts",
    storageBucket: "whjr-arts.appspot.com",
    messagingSenderId: "83258445776",
    appId: "1:83258445776:web:969fbc23465fd2e122b3d5",
    measurementId: "G-4DBGPCDQMQ",
  },
  "whjr-arts"
);

const firebaseArtStaging = firebase.initializeApp(
  {
    apiKey: "AIzaSyA79cHxI3NfnZebgQPkg6MaAYhDmJ4srHI",
    authDomain: "whjr-arts-staging.firebaseapp.com",
    // databaseURL: "https://whjr-arts-default-rtdb.firebaseio.com",
    projectId: "whjr-arts-staging",
    storageBucket: "whjr-arts-staging.appspot.com",
    messagingSenderId: "69140522207",
    appId: "1:69140522207:web:bd64a1e43f4c726fee356a",
    // measurementId: "G-4DBGPCDQMQ",
  },
  "whjr-arts-staging"
);

export { firebaseArtTest, firebaseArtProd, firebaseArtStaging };
export default firebase;
